
<div class="main">
    <ng-content select="[drawer]">
    </ng-content>
</div>